<template>
  <span class="q-avatar2">
    <div class="material-icons" :class="
      Object.values(listNotification).filter((n) => n.s === 1).length > 0
        ? 'notification-online'
        : 'notification-offline'
    ">
      notifications
    </div>
    <div class="notification-size">
      {{ Object.values(listNotification).filter((n) => n.s === 1).length }}

      <q-menu>
        <q-list style="min-width: 100px">
          <span v-for="(key, index) in Object.keys(listNotification)" :key="index">
            <item :notification="{ ...listNotification[key], date: key }" @delete="deleteNotificatio"
              @change="changeNotification" :key="index" />
            <q-separator v-if="Object.keys(listNotification).length != index + 1" spaced inset="item" />
          </span>
        </q-list>
      </q-menu>
    </div>
  </span>
</template>
<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import item from './NotificationItem.vue'
import { GlobalController } from 'src/shared/global/GlobalController'
import { db } from 'src/boot/firebase'
import {
  getDatabase,
  ref,
  get,
  set,
  child,
  update,
  remove,
  onValue,
  onChildAdded,
  onChildChanged,
  onChildRemoved
} from 'firebase/database'

@Component({
  name: 'Notification',
  components: { item }
})
export default class Notification extends Vue {
  listNotification = {};

  getRefNotification () {
    const globalController = GlobalController.getInstance()
    if (globalController && globalController.authResp && globalController.authResp.uidFirebase) {
      return ref(db, `user/${globalController.authResp.uidFirebase}/notification`)
    } else {
      return null
    }
  }

  created () {
    const commentsRef = this.getRefNotification()
    onValue(commentsRef, (snapshot) => {
      const data = snapshot.val()
    })
    onChildAdded(commentsRef, (data) => {
      this.listNotification[data.key] = data.val()
      this.$forceUpdate()
    })
    onChildChanged(commentsRef, (data) => {
      this.listNotification[data.key] = data.val()
      this.$forceUpdate()
    })
    onChildRemoved(commentsRef, (data) => {
      delete this.listNotification[data.key]
      this.$forceUpdate()
    })
  }

  deleteNotificatio ({ key, notification }) {
    const commentsRef = this.getRefNotification()
    remove(child(commentsRef, key))
  }

  changeNotification ({ key, notification }) {
    this.updateStatus(key)
  }

  updateStatus (key) {
    const commentsRef = this.getRefNotification()
    update(child(commentsRef, key), {
      ...this.listNotification[key],
      s: 2
    })
  }

  classNotification (s) {
    return s == 1 ? 'notification-new' : 'notification'
  }
}
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.notification-offline {
  font-size: 30px;
  color: black;
}

.notification-online {
  font-size: 30px;
  color: red;
}

.notification-size {
  display: inline-table;
  text-align: center !important;
  width: 25px;
  height: 20px;
  margin-left: -27px;
  color: black;
  font-size: 10px;
}
</style>
